import { formatMoney, OrderDetails } from '@nemuru-eng/js-api-client';

import { CustomDivider } from '@/components/shared/components/CustomDivider';
import { ReadOnlyDataRow } from '@/components/shared/components/ReadOnlyDataRow';

export function OrderGeneralDetails(props: { orderDetails: OrderDetails }) {
  const { orderDetails: currentOrderDetails } = props;
  const currency = currentOrderDetails.currency;
  return (
    <>
      <ReadOnlyDataRow
        labelTextId={'TOTAL_ORDER'}
        value={formatMoney({ value: currentOrderDetails.totalOrderAmount, currency })}
        boxProps={{ py: 0 }}
      />
      <ReadOnlyDataRow
        labelTextId={'PENDING_TO_CAPTURE'}
        value={formatMoney({
          value: currentOrderDetails.totalOrderAmount - currentOrderDetails.totalCapturedAmount,
          currency,
        })}
        boxProps={{ py: 0 }}
      />
      <CustomDivider margin={2} />
      <ReadOnlyDataRow
        labelTextId={'TOTAL_CAPTURED'}
        value={formatMoney({ value: currentOrderDetails.totalOrderAmount, currency })}
        boxProps={{ py: 0 }}
      />
      <ReadOnlyDataRow
        labelTextId={'TOTAL_REFUNDED'}
        value={formatMoney({ value: currentOrderDetails.totalRefundedAmount, currency })}
        boxProps={{ py: 0 }}
      />
      <CustomDivider margin={2} />
      <ReadOnlyDataRow
        labelTextId={'BILLED'}
        value={formatMoney({
          value: currentOrderDetails.totalCapturedAmount - currentOrderDetails.totalRefundedAmount,
          currency,
        })}
        boxProps={{ py: 0 }}
      />
      {/*<ReadOnlyDataRow
        labelTextId={'TOTAL_FEES'}
        value={
          currentOrderDetails.conditions.totalFeeAmount
            ? formatMoney({ value: currentOrderDetails.conditions.totalFeeAmount, currency })
            : ''
        }
        boxProps={{ py: 0 }}
      />*/}
      <ReadOnlyDataRow
        labelTextId={'TOTAL_PAID'}
        value={formatMoney({ value: currentOrderDetails.totalPaidAmount, currency })}
        boxProps={{ py: 0 }}
      />
    </>
  );
}
